import { IConfigurationRegistry } from "../../../../base/domain/configuration";
import { IConfiguration } from "../../../domain/configuration";
import {
  IDeveloperRegistry,
  IFormatService,
} from "../../../domain/developer";
import { FormatService } from "./FormatService";

export class DeveloperRegistry implements IDeveloperRegistry {
  constructor(private readonly _getToken: () => string, private readonly _configurationRegistry: IConfigurationRegistry<IConfiguration>) {}

  getFormatService(): IFormatService {
    return new FormatService(this._getToken, this._configurationRegistry);
  }
}
